<mat-nav-list>
  <a mat-list-item routerLink="/program" (click)="closeNav()">Programm</a>
  <mat-divider></mat-divider>
  <a
    mat-list-item
    href="https://moodle.bildungswerk-vielfalt.com/"
    target="_blank"
  >Lernplattform</a
  >
  <mat-divider></mat-divider>
  <a mat-list-item routerLink="/education" (click)="closeNav()"
  >Bildungsberatung</a
  >
  <mat-divider></mat-divider>
  <a mat-list-item routerLink="/projects" (click)="closeNav()">Projekte</a>
  <mat-divider></mat-divider>
  <a mat-list-item routerLink="/toolbox-pages" (click)="closeNav()"
  >Toolbox</a
  >
  <mat-divider></mat-divider>
  <a mat-list-item (click)="closeNav()" routerLink="/about-us">Infos</a>
  <mat-divider></mat-divider>
  <button mat-button class="lg">
    <a (click)="closeNav()">En</a> | <a (click)="closeNav()">De</a>
  </button>
  <mat-divider></mat-divider>
</mat-nav-list>
